import React from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Datetime from 'react-datetime';
import moment from 'moment';

interface IServiceSearchBarProps {
    onBackClick?: () => void;
    startDate?: string;
    endDate?: string;
    onStartDateChange?: (date: string) => void;
    onEndDateChange?: (date: string) => void;
    onClearFilters?: () => void;
    loading?: boolean;
}

const ServiceSearchBar: React.FC<IServiceSearchBarProps> = ({
    onBackClick,
    startDate = '',
    endDate = '',
    onStartDateChange,
    onEndDateChange,
    onClearFilters,
    loading = false
}) => {
    const hasActiveFilters = startDate !== '' || endDate !== '';
    const todayPlaceholder = moment().format('MM/DD/YYYY');
    const oneYearLaterPlaceholder = moment().add(1, 'year').format('MM/DD/YYYY');

    const handleClearFilters = () => {
        onClearFilters?.();
    };

    const handleStartDateChange = (value: moment.Moment | string) => {
        if (moment.isMoment(value)) {
            onStartDateChange?.(value.format('YYYY-MM-DD'));
        } else if (typeof value === 'string') {
            onStartDateChange?.(value);
        }
    };

    const handleEndDateChange = (value: moment.Moment | string) => {
        if (moment.isMoment(value)) {
            onEndDateChange?.(value.format('YYYY-MM-DD'));
        } else if (typeof value === 'string') {
            onEndDateChange?.(value);
        }
    };

    return (
        <div className="inventory-search-form">
            <div className="search-bar-container">
                {/* Back Button */}
                <Button className="back-button" onClick={onBackClick}>
                    <FontAwesomeIcon icon={['fas', 'chevron-left']} />
                </Button>

                {/* Date Range Label */}
                <div className="date-range-label">Date Range</div>

                {/* Start Date Input */}
                <div className="date-input-container date-input-start">
                    <span className="date-label">Start:</span>
                    <Datetime
                        timeFormat={false}
                        dateFormat="MM/DD/YYYY"
                        value={startDate ? moment(startDate) : undefined}
                        onChange={handleStartDateChange}
                        inputProps={{
                            disabled: loading,
                            placeholder: todayPlaceholder,
                            className: 'form-control date-input'
                        }}
                    />
                    <FontAwesomeIcon
                        icon={['far', 'calendar-check']}
                        className="calendar-icon"
                    />
                </div>

                {/* End Date Input */}
                <div className="date-input-container date-input-end">
                    <span className="date-label">End:</span>
                    <Datetime
                        timeFormat={false}
                        dateFormat="MM/DD/YYYY"
                        value={endDate ? moment(endDate) : undefined}
                        onChange={handleEndDateChange}
                        inputProps={{
                            disabled: loading,
                            placeholder: oneYearLaterPlaceholder,
                            className: 'form-control date-input'
                        }}
                    />
                    <FontAwesomeIcon
                        icon={['far', 'calendar-check']}
                        className="calendar-icon"
                    />
                </div>

                {/* Clear Button - only show when filters are active */}
                {hasActiveFilters && (
                    <Button
                        className="clear-filters-button"
                        onClick={handleClearFilters}
                        disabled={loading}
                    >
                        <span>Clear</span>
                        <FontAwesomeIcon icon={['far', 'times']} />
                    </Button>
                )}
            </div>
        </div>
    );
};

export default ServiceSearchBar;
